import { KatLitFilteredElement, register } from '../../shared/base';
import { KatHero } from '.';

/**
 * @component {kat-hero-status} KatHeroStatus Component used display hero status.
 */
@register(KatHero.slotMapping.status.name)
export class KatHeroStatus extends KatLitFilteredElement {
  constructor() {
    super(KatHero.slotMapping.status.name, KatHero.slotMapping.status.allowed);
  }
}
